<script setup lang="ts">
    /**
     * this is a wrapper around vuetify `VTextField`.
     *
     * @see https://vuetifyjs.com/en/api/v-text-field/ for list of available props
     */
    export interface VTextFieldProps {
        modelValue?: string;
        placeholder?: string;
        bgColor?: string;
        type?: string;
        suffix?: string;
        variant?:
            | 'outlined'
            | 'filled'
            | 'plain'
            | 'underlined'
            | 'solo'
            | 'solo-inverted'
            | 'solo-filled';
         
        rules?: Array<(value: any) => boolean | string>;
        errorMessages?: string;
        dataTestId?: string;
        inputId?: string;
        maxLength?: string;
        width?: string;
        disabled?: boolean;
    }

    withDefaults(defineProps<VTextFieldProps>(), {
        variant: 'outlined',
        maxLength: '255',
        width: '100%',
    });
</script>

<template>
    <v-hover class="w-100">
        <template #default="{ isHovering, props }">
            <v-textarea
                v-bind="{ ...$attrs, ...props }"
                :id="inputId"
                :width="width"
                color="secondary-text"
                :base-color="isHovering ? 'secondary-text' : 'grey-light-1'"
                variant="outlined"
                density="compact"
                :model-value="modelValue"
                :disabled="disabled"
                maxlength="255"
                @update:model-value="$emit('update:modelValue', $event)"
            />
        </template>
    </v-hover>
</template>

<style scoped lang="scss">
    //:deep(.v-text-field__suffix) {
    //    opacity: 1 !important;
    //}
    //
    //.custom-text-field :deep(.v-field) {
    //    border-radius: 4px !important;
    //}

    //.custom-text-field :deep(.v-field__outline) {
    //    &:hover {
    //        border: 2px solid rgb(var(--v-theme-primary)) !important;
    //    }
    //}

    //
    //    &:not(:hover) {
    //        border: rgb(var(--v-theme-grey-light-1)) !important;
    //    }
    //}

    //.custom-text-field :deep(input) {
    //    border-top-left-radius: 4px !important;
    //    border-bottom-left-radius: 4px !important;
    //}
    //
    //:deep(input) {
    //    color: rgb(var(--v-theme-secondary-text)) !important;
    //
    //    &::placeholder {
    //        color: rgb(var(--v-theme-secondary)) !important;
    //    }
    //}
</style>
